import { tokens, Button } from '@arvoreeducacao/bonsai-ds'
import styled from 'styled-components'

export const ContentContainer = styled.div`
  padding: 0 ${tokens.spacing.insetMedium};
  margin: 0 auto;
  max-width: 451px;
  display: flex;
  flex-direction: column;
  align-items: center;
`

export const StyledImage = styled.img`
  height: auto;
  width: 100%;
`

export const Title = styled.h1`
  color: ${tokens.colors.dark6};
  font-size: ${tokens.fontSize.medium};
  font-weight: ${tokens.fontWeights.bold};
  line-height: ${tokens.lineHeight.medium}%;
  margin: ${tokens.spacing.verticalXxlarge} auto
    ${tokens.spacing.verticalXsmall};
  max-width: 332px;
  text-align: center;

  @media (min-width: ${tokens.breakpoints.tablet}px) {
    font-size: ${tokens.fontSize.large};
    max-width: 413px;
  }
`

export const Text = styled.p<{ a11yEnabled?: boolean }>`
  color: ${({ a11yEnabled }) =>
    a11yEnabled ? tokens.colors.dark5 : tokens.colors.dark4};
  font-size: ${tokens.fontSize.medium};
  line-height: ${tokens.lineHeight.medium}%;
  margin: 0 auto ${tokens.spacing.verticalMedium};
  max-width: 359px;
  text-align: center;
`

export const ButtonGoHome = styled(Button)`
  margin: 0 auto;
`
